import React from 'react';
import {Flex} from '/app/src/component';
import Header from "./Header"

const bodyStyle = {
    color: "Black_M",
    padding: "30px 0px 40px 0px",
    width: "600px",
    fontSize: "20px"
}

const AutomessageUpgrade = () => (
    <Flex column  hAlignContent="center" >
        <Flex>
            <Header
                icon={"/images/Menu_ClientChatAutomessage_L.svg"}
                text={"Du har uppnåt max antal automeddelanden"}/>
        </Flex>
        <Flex {...bodyStyle}>
            Du har nått maxgränsen för hur många automeddelanden du kan skapa.
            Genom att uppgradera till Pro får du tillgång till obegränsat antal
            och kan på så sätt anpassa dem till din domäns olika sidor.
        </Flex>
    </Flex>
)

export default AutomessageUpgrade;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/AutomessageUpgrade.js